import { render, staticRenderFns } from "./LookBookGoodsList.vue?vue&type=template&id=09892ee0&"
import script from "./LookBookGoodsList.vue?vue&type=script&lang=js&"
export * from "./LookBookGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports